import { MenuItem } from "@chakra-ui/react";
import ButtonWithConfirm from "components/Button/ButtonWithConfirm";
import { VThreeDotMenu } from "components/Menu/ThreeDotMenu";
import { useForceSendByPrefixId, useSkipByPrefixId, useRemoveByPrefixId, useActionDetailQueryByPrefixId } from "features/Resources/Shared/hooks";
import { PropsWithChildren } from "react";
import { useNavigate } from "react-router";
import { fromActionPrefixId, isProcessed } from "features/Resources/Shared/helpers";
import { PrefixId } from "features/Resources/Shared/models";
import { confirmRemoveArgs, confirmSendNowArgs } from "features/Resources/Shared/helpers/confirmationArgs";
import CaminoSendNow from "components/Icon/CaminoSendNow";
import CaminoSkip from "components/Icon/CaminoSkip";
import CaminoDelete from "components/Icon/CaminoDelete";
import MenuItemIcon from "components/Icon/MenuItemIcon";

interface MessageEmailThreeDotMenuProps extends PropsWithChildren {
  prefixId: PrefixId;
  removeOnly?: boolean;
}

export default function MessageEmailThreeDotMenu({ prefixId, removeOnly = false }: MessageEmailThreeDotMenuProps) {
  const { resourceType } = fromActionPrefixId(prefixId);

  const { data: resource } = useActionDetailQueryByPrefixId(prefixId);
  const navigate = useNavigate();

  const { mutate: handleForceSend } = useForceSendByPrefixId(prefixId);
  const { mutate: handleSkip } = useSkipByPrefixId(prefixId);
  const { mutate: handleRemove } = useRemoveByPrefixId(prefixId, () => {
    navigate("/");
  });

  if (!resource || isProcessed(resource)) {
    return null;
  }

  return (
    <VThreeDotMenu inPortal>
      {!removeOnly && resource?.status === "skipped" ? (
        null
      ) : (
        <ButtonWithConfirm
          {...confirmSendNowArgs(resourceType)}
          intent="confirmation"
          handleConfirm={() => handleForceSend()}
        >
          <MenuItem icon={<MenuItemIcon icon={CaminoSendNow} />}>{resourceType === "task" ? "Notify & Start Now" : "Send Now"}</MenuItem>
        </ButtonWithConfirm>
      )}
      {!removeOnly && (
        <MenuItem
          onClick={() => handleSkip()}
          icon={<MenuItemIcon icon={CaminoSkip} />}
        >
          {resource?.status === "skipped" ? "Unskip" : "Skip"}
        </MenuItem>
      )}
      <ButtonWithConfirm {...confirmRemoveArgs(resourceType)} intent="confirmation" handleConfirm={() => handleRemove()}>
        <MenuItem icon={<MenuItemIcon icon={CaminoDelete} />}>Delete</MenuItem>
      </ButtonWithConfirm>
    </VThreeDotMenu>
  );
}
